import { TextField, TextFieldProps } from '@mui/material';

type DpInputTextFieldProps = TextFieldProps & {
	fullwidth?: boolean;
};

export const DpInputTextField = ({ fullwidth, ...props }: DpInputTextFieldProps) => (
	<TextField fullWidth={fullwidth} {...props} />
);
